<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">To Carin, the bravest person I know—daughter, cheerleader, caller of bullshit, and creator of plots and agendas. Thanks, Kiddo.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?58c1e927